import api from '../../../api'
export default{
    warehouseUser(params){
      return api[params.method](`/inventory/`+params.url,{params})
    }
}
